import React from 'react';
import { FormattedMessage } from 'react-intl';

import WarningIcon from '@ps-design-system/icons/Warning/Warning24';

export const StreamMaintenanceBanner = () => (
  <div className="flex middle padding-md margin-xl-top bg-cream text-cream-dark">
    <WarningIcon className="h4 no-margin" />
    <div className="margin-md-left text-cream-dark text-small">
      <FormattedMessage
        id="stream.error_banner.message"
        defaultMessage="This page is currently undergoing maintenance, please try again later."
      />
    </div>
  </div>
);
